import _ from "underscore";

export default {
  validateName(str) {
    let valid = true;

    // min length
    if (str.length < 1) valid = false;
    // max length
    if (str.length > 50) valid = false;
    // number words
    if (_.compact(str.split(" ")).length > 3) valid = false;

    return valid;
  }
};
